import { FC, ReactNode, useEffect, useRef, useState } from 'react'
import { Dropdown, MenuProps } from 'antd'
import classNames from 'classnames'
import ButtonBase from '@UI/Button'
import classes from './AddContractDropdown.module.css'

const Button = ButtonBase as unknown as FC<{
  newDesign?: boolean
  className?: string
  type?: 'button' | 'submit' | 'reset'
  children?: ReactNode
}>

type AddContractDropdownProps = {
  className?: string
  onAddFile?: () => void
  onAddTemplate?: () => void
}

const AddContractDropdown: FC<AddContractDropdownProps> = ({
  className,
  onAddFile,
  onAddTemplate,
}) => {
  const [open, setOpen] = useState(false)
  const triggerRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (!open) return undefined

    const closeOnOutsideClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null
      const isTriggerClick = Boolean(triggerRef.current?.contains(target))
      const isMenuClick = Boolean(target?.closest(`.${classes.menu}`))

      if (!isTriggerClick && !isMenuClick) {
        setOpen(false)
      }
    }
    const closeOnScroll = () => setOpen(false)

    document.addEventListener('mousedown', closeOnOutsideClick, true)
    document.addEventListener('scroll', closeOnScroll, true)

    return () => {
      document.removeEventListener('mousedown', closeOnOutsideClick, true)
      document.removeEventListener('scroll', closeOnScroll, true)
    }
  }, [open])

  const menuItems: MenuProps['items'] = [
    {
      key: 'file',
      label: 'Добавить договор файлом',
    },
    {
      key: 'template',
      label: 'Добавить шаблонный договор',
    },
  ]

  const handleMenuClick: MenuProps['onClick'] = ({ key, domEvent }) => {
    domEvent.stopPropagation()
    setOpen(false)

    if (key === 'file') {
      onAddFile?.()
      return
    }

    if (key === 'template') {
      onAddTemplate?.()
    }
  }

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={['click']}
      placement="bottomLeft"
      destroyPopupOnHide
      getPopupContainer={() => document.body}
      overlayClassName={classes.menu}
      overlayStyle={{ minWidth: 'auto', width: 'max-content' }}
      menu={{
        items: menuItems,
        onClick: handleMenuClick,
      }}
    >
      <span ref={triggerRef} className={classes.trigger}>
        <Button newDesign className={classNames(className)} type="button">
          + Добавить договор
        </Button>
      </span>
    </Dropdown>
  )
}

export default AddContractDropdown
